@if (isInitialized) {
  <oe-flat-widget [modalComponent]="modalComponent"
    [icon]="{name:'swap-vertical-outline', color: 'normal'}" [title]="component.alias">
    <oe-flat-widget-line [name]="'MODBUS_TCP_API_READ_WRITE.CURRENT_STATE'| translate" [value]="this.overrideStatus"
    [leftColumnWidth]="10"></oe-flat-widget-line>
  </oe-flat-widget>
}